import { createSlice } from "@reduxjs/toolkit";

export const problemTypeSlice = createSlice({
  name: "problemType",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    problemTypeList: [],
    model: false,
    error_msg: null,
    rowdata: {},
    vehicleList: [],
    customerList: [],
    hpNumberList: [],
    vehicleParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    customerParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    hpNumberParams: { page: 1, page_size: 10, no_of_pages: 0, search: "" },
    problemTypeParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getProblemTypes: (state) => {
      return { ...state, loading: true };
    },
    problemTypeListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.problemTypeParams.page_size
      );
      return {
        ...state,
        listCount: action.payload.response.count,
        problemTypeList: action.payload.response.results,
        loading: false,
        problemTypeParams: {
          ...state.problemTypeParams,
          no_of_pages: noofpages,
        },
      };
    },
    problemTypeAdd: (state) => {
      return { ...state, loading: true };
    },
    problemTypeAddSuccessful: (state) => {
      return { ...state, message: null, loading: false, model: false, rowdata: {} };
    },
    problemTypeEdit: (state, action) => {
      return { ...state, model: true, rowdata: action.payload };
    },
    problemTypeDelete: (state) => {
      return { ...state, loading: false };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return { ...state, model: action.payload, rowdata: {} };
      }
      return { ...state, model: action.payload };
    },
    SetProblemTypeParams: (state, action) => {
      return { ...state, problemTypeParams: action.payload };
    },

    // Vehicle
    getVehicleList: (state) => state,
    vehicleListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.vehicleParams.page_size);
      return {
        ...state,
        vehicleList:
          state.vehicleParams.page === 1
            ? action.payload.results
            : [...state.vehicleList, ...action.payload.results],
        vehicleParams: { ...state.vehicleParams, no_of_pages: noofpages },
      };
    },
    setVehicleParams: (state, action) => {
      return { ...state, vehicleParams: action.payload };
    },

    // Customer
    getCustomerList: (state) => state,
    customerListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.customerParams.page_size);
      return {
        ...state,
        customerList:
          state.customerParams.page === 1
            ? action.payload.results
            : [...state.customerList, ...action.payload.results],
        customerParams: { ...state.customerParams, no_of_pages: noofpages },
      };
    },
    setCustomerParams: (state, action) => {
      return { ...state, customerParams: action.payload };
    },

    // HP Number
    getHpNumberList: (state) => state,
    hpNumberListSuccessful: (state, action) => {
      var noofpages = Math.ceil(action.payload.count / state.hpNumberParams.page_size);
      return {
        ...state,
        hpNumberList:
          state.hpNumberParams.page === 1
            ? action.payload.results
            : [...state.hpNumberList, ...action.payload.results],
        hpNumberParams: { ...state.hpNumberParams, no_of_pages: noofpages },
      };
    },
    setHpNumberParams: (state, action) => {
      return { ...state, hpNumberParams: action.payload };
    },

    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

export const {
  getProblemTypes,
  problemTypeListSuccessful,
  problemTypeAdd,
  problemTypeAddSuccessful,
  problemTypeEdit,
  problemTypeDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetProblemTypeParams,
  getVehicleList,
  vehicleListSuccessful,
  setVehicleParams,
  getCustomerList,
  customerListSuccessful,
  setCustomerParams,
  getHpNumberList,
  hpNumberListSuccessful,
  setHpNumberParams,
} = problemTypeSlice.actions;

export default problemTypeSlice.reducer;
